import * as R from 'ramda'

import { treeToDb } from 'src/lib/graph/walk'

export function set(state, action) {
  return action.payload
}

export function mergeDeep(state, action) {
  return R.mergeDeepRight(state, action.payload)
}

export function setEntity(state, action) {
  const { query, data } = action.payload
  return R.mergeDeepRight(state, treeToDb(query, data))
}

export function setEntities(state, action) {
  const { query, data } = action.payload
  return R.mergeDeepRight(
    state,
    query.reduce(
      (outerAcc, [eids, fragment], outerIndex) => {
        return eids.reduce((innerAcc, id, innerIndex) => {
          const res = data[outerIndex][innerIndex]
          return R.mergeDeepRight(innerAcc, treeToDb(fragment, res))
        }, outerAcc)
      },
      {},
      query
    )
  )
}

export function setCollection(state, action) {
  const { eid, alias, query, res } = action.payload

  let moddedState = state
  // delete collection state to avoid stale params
  if (R.path([eid, alias], state)) {
    moddedState = R.dissocPath([eid, alias], state)
  }

  return R.mergeDeepRight(moddedState, treeToDb(query, res))
}

export function setCollectionFetching(state, action) {
  const { eid, alias, fetching } = action.payload
  return R.assocPath([eid, alias, 'fetching'], fetching, state)
}

export function appendCollection(state, action) {
  const { eid, alias, fragment, entity } = action.payload

  const collection = R.pathOr({}, [eid, alias], state)
  const { '@totalCount': total, data } = collection

  const update = fragment ? treeToDb(fragment, entity) : {}

  update[eid] = {
    [alias]: {
      '@totalCount': R.add(1, total || 0),
      data: R.append(R.prop(':db/id', entity), data || [])
    }
  }

  return R.mergeDeepRight(state, update)
}

export function prependCollection(state, action) {
  const { eid, alias, fragment, entity } = action.payload

  const collection = R.pathOr({}, [eid, alias], state)
  const { '@totalCount': total, '@limit': limit, data } = collection

  const update = fragment ? treeToDb(fragment, entity) : {}

  update[eid] = {
    [alias]: {
      '@totalCount': R.add(1, total || 0),
      data: R.pipe(
        R.ifElse(
          prev => R.lt(R.length(prev), limit),
          R.identity,
          R.dropLast(1)
        ),
        R.prepend(R.prop(':db/id', entity))
      )(data || [])
    }
  }

  return R.mergeDeepRight(state, update)
}
